module.exports = __webpack_public_path__ + "img/ourprograms4.c255d129.png";